import Controller from '@ember/controller';
import { get, set, setProperties } from '@ember/object';
import { service } from '@ember/service';
import { task } from 'ember-concurrency';

export default Controller.extend({
  fundsService: service(),
  router: service(),
  store: service(),

  error: null,
  showValidationErrors: false,

  reset() {
    setProperties(this, {
      error: null,
      showValidationErrors: false,
    });
  },

  save: task(function* () {
    let changeset = get(this, 'model.changeset');
    try {
      yield changeset.validate();
      set(this, 'showValidationErrors', true);
      if (get(changeset, 'isValid')) {
        yield this.fundsService.confirmValidFundToken();
        yield changeset.save();
        this.router.transitionTo(
          'funds.fund.more.donor-hub.connect.downloading',
        );
      }
    } catch (error) {
      if (get(this, 'model.record.errors.length') > 0) {
        get(this, 'model.record.errors').forEach(({ attribute, message }) => {
          changeset.pushErrors(attribute, message);
        });
      } else {
        set(this, 'error', error);
      }
    }
  }).drop(),
});
